import { createRouter, createWebHistory } from "vue-router";
import silentLogin from "@/components/silent_login/Login.vue";
import notfound from "@/views/NotFound.vue";
import login from "../views/nest_views/login.vue";
import servicerepairhistory from "../views/nest_views/service-repair-history.vue";
import plan from "../views/protection-plan/plan.vue";
import purchaseHistory from "../views/protection-plan-partner/purchase-history.vue";
import commisions from "../views/protection-plan-partner/commisions.vue";
import register from "../views/nest_views/register.vue";
import verification from "../views/nest_views/verification.vue";
import forgetPassword from "../views/nest_views/reset-password.vue"
import search from "../views/globalSearch/search.vue";
import protectionPlans from "../views/protection-plan/index.vue";
import { enableScroll } from "../helpers/scrollHelper";
import affiliates from "../views/protection-plan-partner/affiliates.vue";
import partnerList from "../views/protection-plan-partner/bundle-list.vue";
import partnerCheckout from "../views/protection-plan-partner/partner-checkout/chekout.vue";
import thankyou from "../views/protection-plan-partner/partner-checkout/thankyou.vue";
import productList from "../views/protection-plan-partner/products.vue";
import faqPage from "../views/myHappyHome/faq.vue";
import termsAndConditions from "../views/protection-plan-partner/partner-checkout/terms-and-condtion.vue";
import dashboardHappyHome from "../views/myHappyHome/dashboard.vue";
import passwordReset from "../views/nest_views/password-reset.vue"
import privacyPolicy from "../views/myHappyHome/privacy-policy.vue";
import contractorAgreement from "../views/myHappyHome/contractor-agreement.vue";
import contactus from "../views/contact-us.vue";
import paymentMethod from "../views/billingHistory/paymentMethod.vue";
import paymentTransaction from "../views/protection-plan-partner/billing-history-transaction.vue";
import shortenUrl from "../views/redirections/shortenUrl.vue";
import go from "../views/redirections/go.vue";
import claimCreate from "../views/claim/claim-create.vue";
import workOrderHistory from "../views/protection-plan-partner/work-orders-history.vue";
import workOrderHistoryDetail from "../views/protection-plan-partner/work-order-history-detail.vue";
import ratingReview from "../views/protection-plan-partner/ratingReview.vue";
import ssoLogin from "../components/sso/Login.vue";

const routes = [
    {
        path: "/",
        name: "login",
        component: login,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/login",
        name: "login",
        component: login,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/register",
        name: "register",
        component: register,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/verification",
        name: "verification",
        component: verification,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/password/reset",
        name: "passwordReset",
        component: passwordReset,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/forgetPassword",
        name: "forgetPassword",
        component: forgetPassword,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/",
        name: "silentLogin",
        component: silentLogin,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/not-found",
        name: "NotFound",
        meta: {
            requiresAuth: false, // Updated to false for 404 page
            layout: 'auth'
        },
        component: notfound,
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: dashboardHappyHome,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/service-repair-history",
        name: "service-repair-history",
        component: servicerepairhistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/plans/nrg/:id",
        name: "protections-plans",
        component: protectionPlans,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/nrg/plan",
        name: "plan",
        component: plan,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/purchases",
        name: "purchases",
        component: purchaseHistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/commissions",
        name: "commisions",
        component: commisions,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/plans",
        name: "plans",
        component: productList,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/:partnerSlug/:routeSlug",
        name: "partner",
        component: partnerList,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/global-search",
        name: "globalSearch",
        component: search,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/faq",
        name: "faq",
        component: faqPage,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    // ------------------------
    // omega 
    {
        path: "/affiliates",
        name: "affiliates",
        component: affiliates,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },
    // ------------------------
    // partner-checkout 
    {
        path: "/partner/checkout",
        name: "partnerCheckout",
        component: partnerCheckout,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },
    // ------------------------
    // partner-checkout 
    {
        path: "/thankyou",
        name: "thankyou",
        component: thankyou,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
            // layout: 'default'
        },
    },
    // Terms and Conditon
    {
        path: "/terms-and-conditions",
        name: "termsAndConditions",
        component: termsAndConditions,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    },
    // ------------------------
    {
        path: "/happyhome/dashboard",
        name: "dashboardHappyHome",
        component: dashboardHappyHome,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
            // layout: 'default'
        },
    },
    // ------------------------
    {
        path: "/privacy-policy",
        name: "privacyPolicy",
        component: privacyPolicy,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'default'
            // layout: 'default'
        },
    },
    // ------------------------
    {
        path: "/contractor-agreement",
        name: "contractorAgreement",
        component: contractorAgreement,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'auth'
            // layout: 'default'
        },
    },
    {
        path: "/contact-us",
        name: "contactus",
        component: contactus,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
            // layout: 'default'
        },
    },
    // ------------------------
    {
        path: "/billings/methods",
        name: "paymentMethod",
        component: paymentMethod,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    // ------------------------
    {
        path: "/billings/transactions",
        name: "paymentTransaction",
        component: paymentTransaction,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    // ------------------------
    {
        path: "/shorten-url/:id",
        name: "shortenUrl",
        component: shortenUrl,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'auth'
        },
    },
    {
        path: "/go/:slug",
        name: "go",
        component: go,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'auth'
        },
    },
    {
        path: "/claim/create",
        name: "claim",
        component: claimCreate,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/work-order/list",
        name: "workOrders",
        component: workOrderHistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/work-order/detail/:id",
        name: "workOrdersDetail",
        component: workOrderHistoryDetail,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/rating-review",
        name: "ratingReview",
        component: ratingReview,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'auth'
        },
    },

    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: notfound,
        meta: {
            requiresAuth: false,
            layout: 'auth'
        },
    },

    {
        path: "/sso",
        name: "ssoLogin",
        component: ssoLogin,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'auth'
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

router.beforeResolve((to, from, next) => {
    if (to.name) {

    }
    next();
});

router.afterEach(() => {

});




router.beforeEach((to, from, next) => {
    // Redirect root path "/" to "/login"
    if (to.path === "/") {
        return next("/login");
    }

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();

    document.body.classList.remove('modal-open');
    document.documentElement.style.overflow = 'auto';
    document.body.style.paddingRight = '';
    enableScroll();

    const modalEl = document.getElementById('maintenanceModal');
    if (modalEl && modalEl.classList.contains('show')) {
        modalEl.classList.remove('show');
        modalEl.style.display = '';
        modalEl.setAttribute('aria-hidden', 'true');
        modalEl.removeAttribute('aria-modal');
        modalEl.removeAttribute('role');
    }

    let tempUser = localStorage.getItem("user") ?? null;
    let SSOLogin = JSON.parse(localStorage.getItem('SSOLogin')) ?? null

    if (SSOLogin) {
        const allowedRoutes = ['/sso','/plans', '/partner/checkout', '/thankyou'];
        if (!allowedRoutes.includes(to.path)) {
            return next('/plans');
        }
    }

    if ((to.path == "/login" || to.path == "/register" || to.path == "/verification") && tempUser) {
        return next({ name: "dashboard" });
    }

    else if (to.meta.requiresAuth) {
        if (tempUser != null) {
            return next();
        } else {
            return next({ path: '/login', query: { redirectTo: to.fullPath } });
        }
    }
    else {
        return next();
    }
});

export default router;
